/**
 * SiteSection - Site Tab Content
 *
 * Extracts the site configuration from ScenarioEditor Tab 0.
 * Contains:
 * - Site Configuration form fields
 */

import React from 'react';
import { SiteConfiguration } from '../../../components/scenario';

/**
 * SiteSection Component
 *
 * Main component for Tab 0 (Site) content.
 *
 * @param {Object} props
 * @param {Object} props.vortxStyles - Styling object
 * @param {boolean} props.showValidation - Whether to show validation errors
 * @param {Array} props.missingFields - List of missing required fields
 */
function SiteSection({
    vortxStyles,
    showValidation,
    missingFields,
}) {
    return (
        <SiteConfiguration
            vortxStyles={vortxStyles}
            showRequired={showValidation}
            missingFields={missingFields}
        />
    );
}

export default SiteSection;
